import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[dev-func-action-host]'
})
export class DevFuncActionDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}